module.exports = __webpack_public_path__ + "static/img/guojiadili.8f1fdd3b.png";